import { render, staticRenderFns } from "./reasons.vue?vue&type=template&id=440624b6&"
import script from "./reasons.vue?vue&type=script&lang=js&"
export * from "./reasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports